import React, { useState } from "react";
import dayjs from "dayjs";
import Select from "react-select";

export default function Form({empleados, errors, descuento}) {

    const [state, setState] = useState({
        fechaInicio: dayjs().format("YYYY-MM-DD"),
        intervalo: parseInt(descuento.frecuencia) === 15 ? 15 : 1,
        monto: descuento.monto ?? '',
        descripcion: descuento.descripcion ?? '',
        cuotas: descuento.cuotas ? descuento.cuotas.length : 1,
    });

    function updateField( field, value ) {
        setState({
            ...state,
            [field]: value,
        })
    }

    const {cuotas, intervalo, monto, fechaInicio, descripcion} = state;

    let proximasCuotas = [];
    if (cuotas > 1 && monto > 0) {
        const time = intervalo === 15 ? 'day' : 'month';
        for (let index = 0; index < cuotas; index++) {
            proximasCuotas.push({
                fecha: dayjs(fechaInicio).add(index * intervalo, time).format("YYYY-MM-DD"),
                monto: (monto / cuotas).toFixed(2),
            })
        }
    }

    return (
        <div className='popup__body'>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Empleado:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <Select
                            name='empleado_id'
                            isClearable={true}
                            options={empleados
                                .map((empleado) => ({
                                    value: empleado.id,
                                    label: `${empleado.nombreCompleto}`,
                                }))}
                        />
                        {errors.empleado_id && (
                            <small className='help-blockParams form-Text'>
                                {errors.empleado_id[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Fecha Inicio:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='date'
                            name='fecha_inicio'
                            onChange={e => updateField('fechaInicio', e.target.value)}
                            value={fechaInicio}
                            className='form-control'
                        />
                        {errors.fecha_inicio && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha_inicio[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Monto:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='number'
                            name='monto'
                            step='0.01'
                            onChange={e => updateField('monto', e.target.value)}
                            value={monto}
                            required
                            className='text-input form-control'
                        />
                        {errors.monto && (
                            <small className='help-blockParams form-Text'>
                                {errors.monto[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Descripción:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='text'
                            name='descripcion'
                            required
                            onChange={e => updateField('descripcion', e.target.value)}
                            value={descripcion}
                            className='form-control'
                        />
                        {errors.descripcion && (
                            <small className='help-blockParams form-Text'>
                                {errors.descripcion[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Cuotas:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <input
                            type='number'
                            name="cantidad_cuotas"
                            step='1'
                            onChange={e => updateField('cuotas', e.target.value)}
                            value={cuotas}
                            className='text-input form-control'
                        />
                        {errors.cantidad_cuotas && (
                            <small className='help-blockParams form-Text'>
                                {errors.cantidad_cuotas[0]}
                            </small>
                        )}
                    </div>
                </div>
                {/* {cuotas > 1 &&
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Intervalo:
                            </label>
                        </div>
                            <div className='col col-md-8'>
                                <label htmlFor="intervalo_mes" className="inline">
                                    <input
                                        type='radio'
                                        name='frecuencia'
                                        id="intervalo_mes"
                                        checked={intervalo === 1}
                                        onChange={e => updateField('intervalo', 1)}
                                        value='1'
                                    />
                                    Mensual
                                </label>
                                {'    '}
                                <label htmlFor="intervalo_quincenal" className="inline">
                                    <input
                                        type='radio'
                                        name='frecuencia'
                                        id="intervalo_quincenal"
                                        checked={intervalo === 15}
                                        onChange={e => updateField('intervalo', 15)}
                                        value='15'
                                    />
                                    Quincenal
                                </label>
                            </div>
                    </div>
                } */}
                <div className="row form-group">
                    <div className="col-md-12">
                        <table className="table">
                            {proximasCuotas.map((cuota, index) => {
                                return <tr key="index">
                                    <td>
                                        <label>Monto</label>
                                        <input type="text" name={`cuotas[${index}][monto]`} className="text-input form-control" readOnly value={cuota.monto} />
                                    </td>
                                    <td>
                                        <label>Fecha</label>
                                        <input type="date" name={`cuotas[${index}][fecha]`} className="text-input form-control" readOnly value={cuota.fecha}/>
                                    </td>
                                </tr>
                            })}
                        </table>
                    </div>
                </div>
        </div>
    );
}
